import React from 'react'

import { Column, Icon, Row, Text } from '@vividseats/vivid-ui-kit'

import style from './styles.module.scss'

const OverFiltered: React.FC = () => {
    return (
        <Row justify="center-vertical" align="stretch" className={style.overFilteredRow}>
            <Column mb={1.5} noFlex>
                <Icon size="lg" type="search" rounded muted />
            </Column>
            <Column noFlex>
                <Text size="body" weight="bold">
                    Hmm, no tickets match your search
                </Text>
            </Column>
            <Column mt={0.4375} mb={2} noFlex>
                <Text size="body">Try adjusting your filters</Text>
            </Column>
        </Row>
    )
}

export default OverFiltered
